import React, { useState } from "react";
import "../style/Carousel.css";
// Import carousel images
import carousel1 from "../assets/hero.jpg";
import carousel2 from "../assets/carousel_2.png";
import carousel3 from "../assets/carousel_3.png";
import carousel4 from "../assets/carousel_4.png";
import carousel5 from "../assets/carousel_5.JPG";

const images = [
  { src: carousel5, caption: "Cyber Merit Badge" },
  { src: carousel1, caption: "Cyber Defender Summer Scholars Program 2025" },
  { src: carousel2, caption: "Mason High School Visit" },
  { src: carousel3, caption: "Field Trip to US Bank Cyber Fusion Center" },
  { src: carousel4, caption: "Cybersecurity Networking Night" },
];

export default function Carousel() {
  const [index, setIndex] = useState(0);

  const prevSlide = () =>
    setIndex((index - 1 + images.length) % images.length);

  const nextSlide = () =>
    setIndex((index + 1) % images.length);

  return (
    <div className="carousel-wrapper">
      <h2 className="carousel-title">Our Cybersecurity Initiatives</h2>

      <div className="carousel">
        <button className="carousel-btn" onClick={prevSlide}>❮</button>

        <div className="carousel-card">
          <img src={images[index].src} alt={images[index].caption} />
          <p>{images[index].caption}</p>
        </div>

        <button className="carousel-btn" onClick={nextSlide}>❯</button>
      </div>
    </div>
  );
}
